import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'saffron-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss']
})
export class DropzoneComponent implements OnInit {

  constructor() { }

  @Input() maxFileSize = 10; // in MB
  @Input() acceptedFileTypes: string[] = [];
  @Output() filesDropped = new EventEmitter<File[]>();

  isDragging = false;
  errors: string[] = [];

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    
    this.errors = [];
    const files = event.dataTransfer?.files;
    
    if (files) {
      const validFiles = this.validateFiles(files);
      if (validFiles.length > 0) {
        this.filesDropped.emit(validFiles);
      }
    }
  }

  onFileInputChange(event: Event) {
    this.errors = [];
    const element = event.target as HTMLInputElement;
    const files = element.files;
    
    if (files) {
      const validFiles = this.validateFiles(files);
      if (validFiles.length > 0) {
        this.filesDropped.emit(validFiles);
      }
      // Reset the input
      element.value = '';
    }
  }

  private validateFiles(files: FileList): File[] {
    const validFiles: File[] = [];
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      
      // Validate file size
      if (file.size > this.maxFileSize * 1024 * 1024) {
        this.errors.push(`"${file.name}" exceeds the maximum file size of ${this.maxFileSize}MB`);
        continue;
      }
      
      // Validate file type if specified
      if (this.acceptedFileTypes.length > 0) {
        const fileType = file.type;
        if (!this.acceptedFileTypes.some(type => fileType.includes(type))) {
          this.errors.push(`"${file.name}" has an invalid file type`);
          continue;
        }
      }
      
      validFiles.push(file);
    }
    
    return validFiles;
  }

  ngOnInit(): void {
  }

}
